import { render } from "./TheIntroduction.vue?vue&type=template&id=1f2e4b40&scoped=true"
import script from "./TheIntroduction.vue?vue&type=script&lang=js"
export * from "./TheIntroduction.vue?vue&type=script&lang=js"

import "./TheIntroduction.vue?vue&type=style&index=0&id=1f2e4b40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2e4b40"]])

export default __exports__